"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleCharts = void 0;
const loader_1 = require("./loader");
const helper_1 = require("../../core/library/helper");
const library_1 = require("../../core/library");
class GoogleCharts extends library_1.Library {
    constructor() {
        super('GoogleCharts', new loader_1.GoogleChartsLoader());
        return (0, helper_1.withLibraryLoadCheck)(this);
    }
    getChart(node) {
        return new window.google.visualization.GeoChart(node);
    }
    getData(data) {
        return window.google.visualization.arrayToDataTable([['', ''], ...data]);
    }
}
exports.GoogleCharts = GoogleCharts;
/*
var data = google.visualization.arrayToDataTable([
  ['Country', ''],
  ['Germany', 0],
  ['United States', 1],
  ['Brazil', 0],
  ['Canada', 0],
  ['France', 1],
  ['RU', 0]
]);


var options = {enableRegionInteractivity: false, legend: "none", colorAxis: { colors: ["red", "blue"]}};
*/
//# sourceMappingURL=index.js.map